import { ConnectedPageLayout } from 'components/layout/page-layout';
import { Formik } from 'formik';

import { Box } from '@mui/material';

import Typography from '@libs/ui/components/typography';

import { Disclaimer } from './Disclaimer';
import { PerksList } from './content';
import { Filter } from './filter';
import { FormState, PerkRegion } from './types';

interface PerksProps {}

const Perks = (props: PerksProps) => {
  return (
    <Formik<FormState>
      onSubmit={console.log}
      initialValues={{ location: PerkRegion.Global, category: '' }}
    >
      <ConnectedPageLayout
        documentTitle="Perks"
        drawerProps={{}}
        headerProps={{ accountProps: {} }}
      >
        <Box mb={6}>
          <Typography variant="h5">Benefits</Typography>
        </Box>

        <Box mb={4}>
          <Filter />
        </Box>

        <Box mb={8}>
          <Disclaimer />
        </Box>

        <Box>
          <PerksList />
        </Box>
      </ConnectedPageLayout>
    </Formik>
  );
};

export default Perks;
